import { render } from "./Services2Section.vue?vue&type=template&id=125ce095&scoped=true"
import script from "./Services2Section.vue?vue&type=script&lang=js"
export * from "./Services2Section.vue?vue&type=script&lang=js"

import "./Services2Section.vue?vue&type=style&index=0&id=125ce095&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125ce095"]])

export default __exports__